import {
  closeAllDialogs,
  isOtherGame,
  hasElDialogShow,
  isHome,
} from "@/lobby_common/utils/utils.js";
import {
  getLocalStorage,
  removeLocalStorage,
} from "@/lobby_common/utils/auth.js";
import Store from "@/lobby_common/store/index";
import { lock, unLock } from "@/lobby_common/utils/index.js";
import { locationJump } from "@/lobby_common/utils/eventFunction.js";

// import router from '@/lobby_common/router';
class TelegramService {
  constructor() {
    this.tg = null;
  }

  // 初始化方法
  async init() {
    try {
      // 等待 Telegram WebApp 对象可用
      await this.waitForTelegram();
      this.tg = window.Telegram.WebApp;
      // this.tg.expand()
      this.initBackButton();
      return true;
    } catch (error) {
      console.log("Telegram WebApp 初始化失败:", error);
      return false;
    }
  }

  // 等待 Telegram WebApp 加载完成
  waitForTelegram() {
    return new Promise((resolve, reject) => {
      const maxAttempts = 50; // 最大尝试次数
      let attempts = 0;

      const checkTelegram = () => {
        attempts++;
        if (window.Telegram?.WebApp) {
          resolve();
        } else if (attempts >= maxAttempts) {
          reject(new Error("Telegram WebApp 加载超时"));
        } else {
          setTimeout(checkTelegram, 100); // 每100ms检查一次
        }
      };

      checkTelegram();
    });
  }

  // 其他方法需要检查 tg 是否已初始化
  showBackButton() {
    if (this.tg) {
      this.tg.BackButton.show();
    }
  }

  hideBackButton() {
    if (this.tg) {
      this.tg.BackButton.hide();
    }
  }

  initBackButton(callback = null) {
    if (this.tg) {
      if (callback) {
        this.tg.BackButton.onClick(callback);
        return;
      }
      this.tg.BackButton.onClick(() => {
        // 有弹窗直接关闭弹窗
        if (hasElDialogShow()) {
          // 关闭所有开启的弹窗
          closeAllDialogs();
          unLock();
          if (isHome()) {
            setTimeout(() => {
              this.hideBackButton();
            }, 300);
          }
          return;
        }
        // 显示了菜单直接关闭菜单 不继续处理
        if (Store.getters.menuIsShow) {
          Store.dispatch("setMenuBar", false);
          return;
        }
        // 如果是other 游戏 或 brand =2 游戏则返回首页
        const urlParams = new URLSearchParams(window.location.search);
        const brand = urlParams.get("brand");
        const params = new URLSearchParams(window.location.search);
        if (Number(brand) === 2 || isOtherGame()) {
          // 返回首页
          // window.location.href = '/?' + params.toString();
          locationJump("/?" + params.toString());
          this.hideBackButton();
        } else if (window.history.length > 1) {
          // 返回上一页
          window.history.back();
        } else {
          // 一级页面直接返回首页
          // window.location.href = '/?' + params.toString();
        }
      });
    }
  }
}

export default new TelegramService();
